import { useMemo } from "react";
import { useAppContext } from "../../../contexts/AppContext";
import { useSearch } from "../../../contexts/SearchContext";
import { readOrganizedTourAgentHrPercent } from "../utils/resolveOrganizedTourSearchCardPackageIls";

/**
 * Same inputs as the profile «לתשלום» total, so the smart-quote popup,
 * PDF, and public link cannot drift from the price after agent commission.
 */
export function useOrganizedTourDisplayedQuotePricing({
  selectedResult,
  ourPrice,
  orgTourQuoteOverride,
} = {}) {
  const { calculateLDSDealFareForRoomsComposition } = useSearch();
  const { agentEntitlements } = useAppContext();
  const agentHrPercent = readOrganizedTourAgentHrPercent(agentEntitlements);

  return useMemo(
    () => ({
      selectedResult,
      ourPrice,
      orgTourQuoteOverride: orgTourQuoteOverride ?? null,
      calculateLDSDealFareForRoomsComposition,
      agentHrPercent,
    }),
    [
      selectedResult,
      ourPrice,
      orgTourQuoteOverride,
      calculateLDSDealFareForRoomsComposition,
      agentHrPercent,
    ]
  );
}
